export default __webpack_public_path__ + "static/media/lahore.666371e0.png";